var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import * as Enumerable from 'linq';
var BrandLotteryMarginCostDialog = /** @class */ (function () {
    function BrandLotteryMarginCostDialog(dialogClient) {
        this.dialogClient = dialogClient;
    }
    BrandLotteryMarginCostDialog.prototype.getJackpotRangesByLotteryId = function (lotteryId) {
        if (!this.vm.missingMarginCostData || this.vm.missingMarginCostData.length == 0)
            return;
        var lottery = Enumerable.from(this.vm.missingMarginCostData).firstOrDefault(function (x) { return x.lotteryId == lotteryId; });
        if (!lottery || !lottery.lotteryJackpotRanges)
            return;
        return lottery.lotteryJackpotRanges.map(function (x) { return "(".concat(x.rangeFrom, " - ").concat(x.rangeTo, ")"); }).join(", ");
    };
    BrandLotteryMarginCostDialog.prototype.activate = function (model) {
        this.vm = model;
    };
    BrandLotteryMarginCostDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    BrandLotteryMarginCostDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService])
    ], BrandLotteryMarginCostDialog);
    return BrandLotteryMarginCostDialog;
}());
export { BrandLotteryMarginCostDialog };
